// extracted by mini-css-extract-plugin
export default {"personalAddressItem":"UserAddressButton_personalAddressItem__hITJI","address":"UserAddressButton_address__4sWEu"};